import { number, string, oneOfType } from 'prop-types';

import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { N0, N50 } from '@assets/colors';
import stySkeleton from './style';

const SkeletonLoad = props => (
  <div className={stySkeleton(props)}>
    <SkeletonTheme color={N50} highlightColor={N0}>
      <Skeleton {...props} />
    </SkeletonTheme>
  </div>
);

SkeletonLoad.propTypes = {
  bottom: oneOfType([string, number]),
  height: oneOfType([string, number]),
  top: oneOfType([string, number]),
  width: oneOfType([string, number]),
};

SkeletonLoad.defaultProps = {
  bottom: 0,
  height: 0,
  top: 0,
  width: '100%',
};

export default SkeletonLoad;
